import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    selectedKey: undefined
  },
  mutations: {
    updateSelectedKey (state, key) {
      // 变更状态
      state.selectedKey = key
    }
    // store.commit('updateSelectedKey', key)
  },
  getters: {
    getSelectedKey (state) {
      return state.selectedKey
    }
  },
  actions: {
    setSelectedKey ({ commit }, key) {
      commit('updateSelectedKey', key)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js